const shadows = {
  outline: "0 0 0 3px rgba(244, 188, 255, 0.75)",
};

export default shadows;
